import React, { useEffect, useContext, useState } from 'react'
import AdminContext from '../../StateContext/Application';
import { apiurl } from '../../../../path';
import "./cashbook.css";
import { useLanguage } from '../../../../lang/langcontext/LanguageContext';
import GooglePagination from '../../styles/GooglePagination';

const CashBook = () => {
    const { language, toggleLanguage, t } = useLanguage();
    const context = useContext(AdminContext)
    const { GetCashBookReport } = context
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [filteredBills, setFilteredBills] = useState([]);
    const billsPerPage = 10; // Show 10 bills per page
    // Pagination logic
    const totalPages = Math.ceil(data.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills.slice(indexOfFirstBill, indexOfLastBill);

    const getCashBookReport = async () => {
        try {
            const data = await GetCashBookReport()
            setData(data)
            setFilteredBills(data)
        } catch (error) {
            console.error("Error in GetProjects:", error);
        }
    }
    useEffect(() => {
        getCashBookReport()
    }, []);


    useEffect(() => {
        const term = searchTerm.toLowerCase();
        const filtered = data.filter(bill =>
            Object.values(bill).some(val =>
                (val || '').toString().toLowerCase().includes(term)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1);
    }, [searchTerm, data]);


    // Current Page Totals
    const pageDebitTotal = currentBills.reduce(
        (sum, item) => sum + Number(item.Debit || 0),
        0
    );

    const pageCreditTotal = currentBills.reduce(
        (sum, item) => sum + Number(item.Credit || 0),
        0
    );

    const pageBalanceTotal = currentBills.reduce(
        (sum, item) => sum + Number(item.Balance || 0),
        0
    );

    // Gross Totals (All Records)
    const grossDebitTotal = filteredBills.reduce(
        (sum, item) => sum + Number(item.Debit || 0),
        0
    );

    const grossCreditTotal = filteredBills.reduce(
        (sum, item) => sum + Number(item.Credit || 0),
        0
    );

    const grossBalanceTotal = filteredBills.reduce(
        (sum, item) => sum + Number(item.Balance || 0),
        0
    );
    
    return (
        <>
            <div className="col-12" style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">

                    <div className="col-12">

                        <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
                            <h5 className='my-auto fw-bold'>
                                <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                                <span className='my-auto'>{t("Cash Book")}</span>
                            </h5>

                            <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                                <img
                                    src="/Search32.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "10px",
                                        transform: "translateY(-50%)",
                                        width: "16px",
                                        height: "16px",
                                        opacity: 0.6
                                    }}
                                />
                                <input
                                    type="text"
                                    placeholder={t("Search Here")}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    value={searchTerm}
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px 8px 32px", // left padding makes space for icon
                                        border: "1px solid #ccc",
                                        borderRadius: "8px",
                                        backgroundColor: "#f1f6fc",
                                        fontSize: "14px",
                                        color: "#333",
                                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                        outline: "none"
                                    }}
                                />
                            </div>
                        </div>

                        <div className="col-12 pb-5">
                            <div className="col-12 mb-3" style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px" }}>
                                <div className='col-12 tableDesign' style={{ background: '#2C78DB' }}>
                                    <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse', fontSize: "18px" }}>
                                        <thead>
                                            <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                                <th style={{ width: "5%", padding: "8px" }}>{t("Sr No")}</th>
                                                <th style={{ width: "14%", padding: "8px" }}>{t("Date")}</th>
                                                <th style={{ width: "25%", padding: "8px" }}>{t("Description")}</th>
                                                <th style={{ width: "10%", padding: "8px" }}>{t("Debit")}</th>
                                                <th style={{ width: "10%", padding: "8px" }}>{t("Credit")}</th>
                                                <th style={{ width: "10%", padding: "8px" }}>{t("Balance")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentBills?.length === 0 ? (
                                                <tr>
                                                    <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                                        {t("No data available")}
                                                    </td>
                                                </tr>
                                            ) : (
                                                currentBills && currentBills.map((e, index) => {
                                                    const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                    return (
                                                        <tr style={{ backgroundColor: bgColor, fontSize: "18px", fontWeight: "400" }} key={index}>
                                                            <td style={{ padding: '8px' }}>{(currentPage - 1) * billsPerPage + index + 1}</td>
                                                            <td style={{ padding: '8px' }}>{new Date(e.Date).toLocaleString()}</td>
                                                            <td style={{ padding: '8px' }}>{e.Description}</td>
                                                            <td style={{ padding: '8px' }}>{e.Debit}</td>
                                                            <td style={{ padding: '8px' }}>{e.Credit} </td>
                                                            <td style={{ padding: '8px' }}>{e.Balance}</td>
                                                        </tr>
                                                    );
                                                })
                                            )}

                                            <tr
                style={{
                     backgroundColor: "#f0f0f0",
                                fontWeight: "bold",
                                   borderTop: "2px solid black",
                                           fontSize: "18px" 
                                                }}
                                            >
                                                <td colSpan="3" style={{ textAlign: "right"}}>
                                                    Page Total
                                                </td>
                                                <td>₹ {pageDebitTotal.toLocaleString("en-IN")}</td>
                                                <td>₹ {pageCreditTotal.toLocaleString("en-IN")}</td>
                                                <td>₹ {pageBalanceTotal.toLocaleString("en-IN")}</td>
                                            </tr>

                                            {/* Gross Total */}
                                            <tr
                                                style={{
                                                    backgroundColor: "#f0f0f0",
                                                    fontWeight: "bold",
                                                    borderTop: "2px solid black",
                                                    fontSize: "18px" 
                                                }}
                                            >
                                                <td colSpan="3" style={{ textAlign: "right"}}>
                                                    Gross Total
                                                </td>
                                                <td>₹ {grossDebitTotal.toLocaleString("en-IN")}</td>
                                                <td>₹ {grossCreditTotal.toLocaleString("en-IN")}</td>
                                                <td>₹ {grossBalanceTotal.toLocaleString("en-IN")}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className='col-12 mt-4'>
                                    <div className="row">
                                        <div className="col-6">
                                            <p className="text-gray-600" style={{ fontSize: "18px" }}>
                                                {t("Showing")} {indexOfFirstBill + 1} {t("to")} {Math.min(indexOfLastBill, filteredBills.length)} {t("of")} {data.length} {t("entries")}
                                            </p>
                                        </div>

                                        <div className="col-6 text-end ">
                                            <GooglePagination
  currentPage={currentPage}
  totalPages={totalPages}
  onPageChange={setCurrentPage}
/>
                                        </div>

                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>





                </div>
            </div>


        </>
    )
}

export default CashBook